import { render } from "./UserPermissionList.vue?vue&type=template&id=a9d47eac&scoped=true"
import script from "./UserPermissionList.vue?vue&type=script&lang=js"
export * from "./UserPermissionList.vue?vue&type=script&lang=js"

import "./UserPermissionList.vue?vue&type=style&index=0&id=a9d47eac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d47eac"]])

export default __exports__